import React from "react";
import debug from "debug";
import { Accept, DropzoneState, FileRejection } from "react-dropzone";
import { FileUploadConfig } from "@bonliva-crm/shared";
const log = debug("app:DnDContainer:DnDStore");

export type DropListener = (acceptedFiles: File[]) => void;

export type DropFilesEventHandler = (
  accepted: File[],
  rejected: FileRejection[],
  event: React.DragEvent<HTMLDivElement>
) => void;

type DnDContext = {
  dzProps: DropzoneState;
  listen: (listener: DropListener) => void;
  listener: DropListener;
  acceptDroppedFiles: DropFilesEventHandler;
  accept: Accept;
};

export class DnDStore {
  private _listener: DropListener | null = null;

  config = new FileUploadConfig();

  get listener() {
    return this._listener;
  }

  listen = (listener: DropListener) => {
    log("listen");
    this._listener = listener;
  };

  acceptDroppedFiles = (
    accepted: File[],
    rejected: FileRejection[],
    event: React.DragEvent<HTMLDivElement>
  ) => {
    log("acceptDroppedFiles", { accepted, rejected });
    this._listener && this._listener(accepted);
  };
}

export const DnDContext = React.createContext<DnDContext>(null);
